import React, { useState } from 'react';
import { Card, Button, Radio, Input, Modal, message, Divider, Statistic } from 'antd';
import { WalletOutlined, QrcodeOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';

const { Countdown } = Statistic;

const RechargePage = () => {
  const { user } = useAuth();
  const [amount, setAmount] = useState(100);
  const [customAmount, setCustomAmount] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [qrCode, setQrCode] = useState('');
  const [orderId, setOrderId] = useState('');
  const [deadline, setDeadline] = useState(null);

  const rechargeOptions = [
    { value: 50, label: '50元', bonus: 0 },
    { value: 100, label: '100元', bonus: 10 },
    { value: 200, label: '200元', bonus: 30 },
    { value: 500, label: '500元', bonus: 100 },
    { value: 1000, label: '1000元', bonus: 250 },
  ];

  const handleRecharge = async () => {
    const finalAmount = amount === 'custom' ? parseInt(customAmount) : amount;
    
    if (!finalAmount || finalAmount < 1) {
      message.error('请输入有效的充值金额');
      return;
    }

    // 模拟创建订单
    const mockOrderId = 'ORD' + Date.now();
    setOrderId(mockOrderId);
    
    // 模拟生成微信支付二维码（实际应该调用后端API）
    // 这里使用一个占位图片
    setQrCode('https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=weixin://wxpay/' + mockOrderId);
    
    // 设置支付倒计时（5分钟）
    setDeadline(Date.now() + 5 * 60 * 1000);
    
    setIsModalVisible(true);
    
    // 模拟支付成功（实际应该轮询订单状态）
    setTimeout(() => {
      message.success('充值成功！');
      setIsModalVisible(false);
      // 刷新用户积分（实际应该重新获取用户信息）
      window.location.reload();
    }, 5000);
  };

  const handleAmountChange = (e) => {
    setAmount(e.target.value);
  };

  const getBonus = () => {
    if (amount === 'custom') return 0;
    const option = rechargeOptions.find(opt => opt.value === amount);
    return option ? option.bonus : 0;
  };

  const getTotal = () => {
    const base = amount === 'custom' ? parseInt(customAmount) || 0 : amount;
    return base + getBonus();
  };

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '24px' }}>
      <Card title="账户充值" bordered={false}>
        {/* 当前余额 */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 16, color: '#666', marginBottom: 8 }}>当前积分</div>
          <div style={{ fontSize: 48, fontWeight: 'bold', color: '#1890ff' }}>
            {user?.points || 0}
          </div>
          <div style={{ fontSize: 14, color: '#999', marginTop: 8 }}>
            会员类型：{user?.type || '普通会员'}
          </div>
        </div>

        <Divider />

        {/* 充值金额选择 */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 16 }}>
            选择充值金额
          </div>
          <Radio.Group
            value={amount}
            onChange={handleAmountChange}
            style={{ width: '100%' }}
          >
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
              {rechargeOptions.map((option) => (
                <Radio.Button
                  key={option.value}
                  value={option.value}
                  style={{
                    height: 'auto',
                    padding: '16px',
                    textAlign: 'center',
                    position: 'relative',
                  }}
                >
                  <div style={{ fontSize: 20, fontWeight: 'bold' }}>
                    {option.label}
                  </div>
                  {option.bonus > 0 && (
                    <div
                      style={{
                        fontSize: 12,
                        color: '#fff',
                        background: '#ff4d4f',
                        padding: '2px 8px',
                        borderRadius: 4,
                        position: 'absolute',
                        top: -8,
                        right: -8,
                      }}
                    >
                      送{option.bonus}
                    </div>
                  )}
                </Radio.Button>
              ))}
              <Radio.Button
                value="custom"
                style={{
                  height: 'auto',
                  padding: '16px',
                  textAlign: 'center',
                }}
              >
                <div style={{ fontSize: 16 }}>自定义金额</div>
              </Radio.Button>
            </div>
          </Radio.Group>
        </div>

        {/* 自定义金额输入 */}
        {amount === 'custom' && (
          <div style={{ marginBottom: 24 }}>
            <Input
              type="number"
              placeholder="请输入充值金额"
              value={customAmount}
              onChange={(e) => setCustomAmount(e.target.value)}
              size="large"
              prefix="¥"
              style={{ maxWidth: 300 }}
            />
          </div>
        )}

        {/* 充值信息 */}
        <div
          style={{
            background: '#f5f5f5',
            padding: '16px',
            borderRadius: 8,
            marginBottom: 24,
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span>充值金额：</span>
            <span style={{ fontWeight: 'bold' }}>
              ¥{amount === 'custom' ? customAmount || 0 : amount}
            </span>
          </div>
          {getBonus() > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
              <span>赠送积分：</span>
              <span style={{ fontWeight: 'bold', color: '#ff4d4f' }}>+{getBonus()}</span>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 18 }}>
            <span>实际到账：</span>
            <span style={{ fontWeight: 'bold', color: '#1890ff' }}>{getTotal()} 积分</span>
          </div>
        </div>

        {/* 充值按钮 */}
        <Button
          type="primary"
          size="large"
          block
          icon={<WalletOutlined />}
          onClick={handleRecharge}
          disabled={amount === 'custom' && !customAmount}
        >
          立即充值
        </Button>

        <div style={{ marginTop: 16, fontSize: 12, color: '#999', textAlign: 'center' }}>
          充值即表示您同意《充值服务协议》
        </div>
      </Card>

      {/* 微信支付弹窗 */}
      <Modal
        title="微信支付"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsModalVisible(false)}>
            取消支付
          </Button>,
        ]}
        centered
      >
        <div style={{ textAlign: 'center', padding: '24px' }}>
          <div style={{ fontSize: 16, marginBottom: 16 }}>
            订单号：{orderId}
          </div>
          <div style={{ marginBottom: 16 }}>
            <img
              src={qrCode}
              alt="微信支付二维码"
              style={{ width: 200, height: 200 }}
            />
          </div>
          <div style={{ fontSize: 14, color: '#666', marginBottom: 16 }}>
            <QrcodeOutlined style={{ marginRight: 8 }} />
            请使用微信扫一扫完成支付
          </div>
          {deadline && (
            <div style={{ fontSize: 14, color: '#ff4d4f' }}>
              支付倒计时：
              <Countdown
                value={deadline}
                format="mm:ss"
                onFinish={() => {
                  message.error('支付超时，请重新下单');
                  setIsModalVisible(false);
                }}
              />
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default RechargePage;
